import { api, formHeaders } from "@";

// Save classifications details
export const saveClassifications = (form) => {
  if (form.id) {
    return api.put(`/api/AdminClassifications/${form.id}`, form, formHeaders);
  }
  return api.post(`/api/AdminClassifications`, form, formHeaders);
};
